import React from 'react';
import 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import { useUpdateClientDetailsHook } from '../Admin/Modal/EditClient/hook';
import { FiBarChart2 } from 'react-icons/fi';
import { useTheme } from '../theme/ThemeProvider';
import { chartTheme } from '../theme/chartTheme';

const ClickStats = ({ initialShortCode }) => {
  const { resolvedTheme } = useTheme();
  const colors = chartTheme(resolvedTheme);

  const { clickStatsListByShortCode, getUrlbyInitShortCode } = useUpdateClientDetailsHook(window.location.pathname.replace("/list/view/", ""))

  React.useEffect(() => {
    getUrlbyInitShortCode(initialShortCode);
  }, [initialShortCode, getUrlbyInitShortCode]);

  if (!clickStatsListByShortCode) return <div className="details-chart-loading" role="status">Loading engagement...</div>;

  const stats = [...clickStatsListByShortCode].sort((first, second) => new Date(first._id) - new Date(second._id));
  const hasClicks = stats.some((entry) => Number(entry.clicks) > 0);

  const data = {
    labels: getLabels(stats),
    datasets: [
      {
        label: "Clicks",
        data: getCount(stats),
        fill: 'origin',
        borderColor: colors.line,
        borderWidth: 2.5,
        tension: 0.3,
        pointRadius: stats.length === 1 ? 5 : 3,
        pointHoverRadius: 6,
        pointBackgroundColor: colors.surface,
        pointBorderWidth: 2,
        backgroundColor: ({ chart }) => {
          const { ctx, chartArea } = chart;
          const fill = resolvedTheme === 'dark' ? '168, 205, 235' : '20, 184, 166';
          if (!chartArea) return `rgba(${fill}, 0.12)`;
          const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          gradient.addColorStop(0, `rgba(${fill}, 0.34)`);
          gradient.addColorStop(0.65, 'rgba(59, 130, 246, 0.10)');
          gradient.addColorStop(1, 'rgba(59, 130, 246, 0.01)');
          return gradient;
        }
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { intersect: false, mode: 'index' },
    plugins: {
      legend: { display: false },
      tooltip: { backgroundColor: colors.tooltip, titleColor: colors.tooltipInk, bodyColor: colors.tooltipInk, padding: 12, cornerRadius: 6, displayColors: false }
    },
    scales: {
      x: { grid: { display: false }, border: { display: false }, ticks: { color: colors.muted, maxRotation: 0, maxTicksLimit: 6, font: { size: 11 } } },
      y: { beginAtZero: true, suggestedMax: hasClicks ? undefined : 5, border: { display: false }, grid: { color: colors.grid }, ticks: { precision: 0, maxTicksLimit: 6, color: colors.muted, padding: 10, font: { size: 11 } } }
    }
  };



  function getLabels(data = [{ _id: "" }]) {

    const labels = [];
    data.forEach(element => {
      labels.push(new Date(element._id).toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' }))

    });
    return labels;
  }


  function getCount(data = [{ clicks: 0 }]) {
    const countData = [];
    data.forEach(element => {
      countData.push(element.clicks)
    });
    return countData;
  }

  return (
    <div className="details-chart-shell">
      <div className="details-chart-canvas">
        <Line data={data} options={options} role="img" aria-label={`Daily clicks chart: ${stats.length} recorded days`} />
      </div>
      {!hasClicks && (
        <div className="details-chart-empty" role="status">
          <span aria-hidden="true"><FiBarChart2 /></span>
          <strong>No clicks yet</strong>
          <p>Engagement will appear here after the first click.</p>
        </div>
      )}
    </div>

  )
}

export default ClickStats